export const ManagerPostPanelPageTranslations = {
  POST_PANEL_PAGE_TITLE: {
    es: 'Noticias',
    en: 'News',
    cat: 'Notícies',
    eus: 'Berriak',
    pt: 'Notícias'
  },
  DRAFTS: {
    es: 'Borradores',
    en: 'Drafts',
    cat: 'Esborranys',
    eus: 'Zirriborroak',
    pt: 'Rascunhos'
  },
  SCHEDULED: {
    es: 'Programadas',
    en: 'Scheduled',
    cat: 'Programades',
    eus: 'Programatuta',
    pt: 'Programadas'
  },
  PUBLISHED: {
    es: 'Enviadas',
    en: 'Published',
    cat: 'Enviades',
    eus: 'Argitaratuta',
    pt: 'Publicadas'
  },
  CREATED_BY_ME: {
    es: 'Creadas por ti',
    en: 'Created by you',
    cat: 'Creades per tu',
    eus: 'Zure sortuak',
    pt: 'Criadas por você'
  },
  SELECT_TOPIC: {
    es: 'Tema',
    en: 'Topic',
    cat: 'Tema',
    eus: 'Gaia',
    pt: 'Tema'
  },
  SELECT_TAGS: {
    es: 'Formación',
    en: 'Formation',
    cat: 'Formació',
    eus: 'Formazio',
    pt: 'Formação'
  },
  GLOBAL_NEWS: {
    es: 'Noticia global',
    en: 'Global news',
    cat: 'Notícia global',
    eus: 'Berri globala',
    pt: 'Notícia global'
  },
  SELECT_PUBLISH_DATE: {
    es: 'Fecha de publicación',
    en: 'Publish date',
    cat: 'Data de publicació',
    eus: 'Argitalpen data',
    pt: 'Data de publicação'
  },
  SEARCH_PLACEHOLDER: {
    es: 'Buscar noticia por título',
    en: 'Search news by title',
    cat: 'Cercar notícia pel títol',
    eus: 'Bilatu notizia izenburuaren arabera',
    pt: 'Pesquisar notícia pelo título'
  },
  TODAY: {
    es: 'Hoy',
    en: 'Today',
    cat: 'Avui',
    eus: 'Gaur',
    pt: 'Hoje'
  },
  YESTERDAY: {
    es: 'Ayer',
    en: 'Yesterday',
    cat: 'Ahir',
    eus: 'Atzo',
    pt: 'Ontem'
  },
  NO_NEWS_TO_SHOW: {
    es: 'No hay noticias para mostrar',
    en: 'No news to show',
    cat: 'No hi ha notícies per mostrar',
    eus: 'Ez dago erakusteko berririk',
    pt: 'Sem notícias para mostrar'
  },
  TITLE_GROUP_DATE: {
    es: '{{dateName}}, {{dateDay}} de {{dateMonth}} del {{dateYear}}',
    en: '{{dateName}}, {{dateDay}} of {{dateMonth}} {{dateYear}}',
    cat: '{{dateName}}, {{dateDay}} de {{dateMonth}} del {{dateYear}}',
    eus: '{{dateName}}, {{dateDay}} {{dateMonth}} {{dateYear}}',
    pt: '{{dateName}}, {{dateDay}} de {{dateMonth}} de {{dateYear}}'
  },
  TITLE_GROUP_DATE_THIS_YEAR: {
    es: '{{dateName}}, {{dateDay}} de {{dateMonth}}',
    en: '{{dateName}}, {{dateDay}} of {{dateMonth}}',
    cat: '{{dateName}}, {{dateDay}} de {{dateMonth}}',
    eus: '{{dateName}}, {{dateDay}} {{dateMonth}}',
    pt: '{{dateName}}, {{dateDay}} de {{dateMonth}}'
  },
  EMPTY_MESSAGE_DRAFT_TITLE: {
    es: 'Aún no tienes noticias en borrador',
    en: 'You have no news in draft',
    cat: 'No tens notícies en esborrany',
    eus: 'Ez dago berririk zirriborroan',
    pt: 'Você não tem notícias em rascunho'
  },
  EMPTY_MESSAGE_DRAFT_DESCRIPTION: {
    es: 'Empieza a escribir una noticia en cualquier momento y guárdala aquí si todavía no está lista. Podrás revisarla, ajustarla y enviarla cuando quieras.',
    en: 'Start writing a news at any time and save it here if it is not yet ready. You can review it, adjust it and send it when you want.',
    cat: 'Comenceu a escriure una notícia en qualsevol moment i deseu-la aquí si encara no està llista. Podeu revisar-la, ajustar-la i enviar-la quan vulgueu.',
    eus: 'Hasi berri bat idatzi nahi duzun edozein unean eta gordezu hemen bestela ez dagoela lista. Ikusi, ajustatu eta bidali nahi duzun unean.',
    pt: 'Comece a escrever uma notícia em qualquer momento e salve-a aqui se ainda não estiver pronta. Você pode revisar, ajustar e enviar quando quiser.'
  },
  EMPTY_MESSAGE_SCHEDULED_TITLE: {
    es: 'Escribe ahora, envía más tarde',
    en: 'Write now, send later',
    cat: 'Escriu ara, envia més tard',
    eus: 'Idatzi orain, bidali geroago',
    pt: 'Escreva agora, envie mais tarde'
  },
  EMPTY_MESSAGE_SCHEDULED_DESCRIPTION: {
    es: 'Programa tus noticias para enviarlas en otro momento o en un día diferente. Permanecerán aquí hasta que se envíen.',
    en: 'Schedule your news to send them at another time or on a different day. They will remain here until they are sent.',
    cat: "Programa les teves notícies per enviar-les en un altre moment o en un dia diferent. Es quedaran aquí fins que 'enviïn'.",
    eus: 'Programatu zure berririk beste unean edo beste egun batean bidali. Ez dira hemen geratu berriak bidali arte.',
    pt: 'Programe suas notícias para enviá-las em outro momento ou em um dia diferente. Eles permanecerão aqui até serem enviados.'
  },
  EMPTY_MESSAGE_PUBLISHED_TITLE: {
    es: 'Aún no hay noticias enviadas',
    en: 'You have no news sent',
    cat: 'No tens notícies enviades',
    eus: 'Ez dago argitaratutako berririk',
    pt: 'Você não tem notícias enviadas'
  },
  EMPTY_MESSAGE_PUBLISHED_DESCRIPTION: {
    es: 'Cuando publiques una noticia, aparecerá aquí. Podrás revisar el historial de envíos y ver todos los detalles de cada publicación.',
    en: 'When you publish a news, it will appear here. You can review the history of sent posts and see all the details of each publication.',
    cat: 'Quan publiques una notícia, apareixerà aquí. Podeu revisar el historial d`enviaments i veure tots els detalls de cada publicació.',
    eus: 'Berria argitaratu duzunean, hemen agertuko da. Ikusi bidali dituzun berrien historia eta ikusi publikazio bakoitzaren xehetasun guztiak.',
    pt: 'Quando publicar uma notícia, aparecerá aqui. Você pode revisar o histórico de envios e ver todos os detalhes de cada publicação.'
  },
  NO_RESULTS_FOUND: {
    es: 'No se encontraron resultados',
    en: 'No results found',
    cat: 'No s`han trobat resultats',
    eus: 'Ez da emaitzarik aurkitu',
    pt: 'Não foram encontrados resultados'
  }
};
